<template>
<div class="chapter">
<div class="inner_page">
<p class="CTA"><span epub:type="pagebreak" id="pagevii" title="vii"></span><a href="#/Text/Contents#epi"><span class="blue">Epigraph</span></a></p>
<div class="imgdes2">
<img src="Images/designtop.jpg"/>
</div>
<p class="CEPI1"><span epub:type="pagebreak" id="pageviii" title="viii"></span>With fame comes opportunity, but it also includes responsibility—to advocate and share, to focus less on glass slippers and more on pushing through glass ceilings. And, if I’m lucky enough, to inspire.</p>
<p class="CEPC">—M<span class="sc">EGHAN</span> M<span class="sc">ARKLE</span></p>
<p class="CEPI">The world is changing as everybody knows, and we’ve changed with it. I think everybody can see that.</p>
<p class="CEPC">—P<span class="sc">RINCE</span> H<span class="sc">ARRY OF</span> W<span class="sc">ALES</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epigraph.vue?67a38ac4